import { commonRegx } from "xcommon-node/src/common/commonRegx";

export class DtoFileReportsGetRes {
    public url: string = "";
    public outputqueue_code: string = "";
}
